// extend
export var Page = function () { return null; };
